var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg2 = function Svg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.922 74H.094l19.781-26.39c2.25-3 4.14-5.672 5.672-8.016 1.531-2.375 2.734-4.469 3.61-6.282 1.718-3.406 2.577-6.906 2.577-10.5 0-1.968-.406-3.53-1.218-4.687-.813-1.156-1.922-1.734-3.328-1.734-3.125 0-4.688 2.937-4.688 8.812v1.125c.031.438.063.953.094 1.547H3.609l-.093-2.625c0-7.281 2.25-13.25 6.75-17.906C14.796 2.656 20.594.312 27.656.312c6.813 0 12.375 2.22 16.688 6.657 4.343 4.343 6.515 10.015 6.515 17.015 0 5.625-1.484 11.094-4.453 16.407-1.5 2.656-3.453 5.453-5.86 8.39-2.374 2.907-5.265 5.969-8.671 9.188 2.938-.219 5.89-.375 8.86-.469 3-.094 6.062-.14 9.187-.14V74Z",
    fill: "#121213"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#2_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.547 39.594c-1.531 2.343-3.422 5.015-5.672 8.015L.094 74h49.828V57.36a290.33 290.33 0 0 0-9.188.14 208.495 208.495 0 0 0-8.859.469 127.96 127.96 0 0 0 2.23-2.158c2.456-2.437 4.604-4.78 6.442-7.03 2.406-2.937 4.36-5.734 5.86-8.39 2.968-5.313 4.452-10.782 4.452-16.407 0-7-2.172-12.672-6.515-17.015C40.03 2.53 34.469.312 27.656.312c-7.062 0-12.86 2.344-17.39 7.032-4.5 4.656-6.75 10.625-6.75 17.906l.093 2.625h18.985a85.04 85.04 0 0 0-.094-1.547v-1.125c0-5.875 1.563-8.812 4.688-8.812 1.406 0 2.515.578 3.328 1.734.812 1.156 1.218 2.719 1.218 4.688 0 3.593-.859 7.093-2.578 10.5-.875 1.812-2.078 3.906-3.61 6.28Zm5.403-5.396c-.921 1.905-2.167 4.067-3.722 6.48l-.007.01c-1.561 2.39-3.478 5.097-5.746 8.12 0 .001 0 0 0 0L4.092 72h43.83V59.366c-2.414.016-4.79.06-7.125.133m0 0c-2.94.093-5.865.248-8.773.464l-5.614.418 4.091-3.866c3.359-3.174 6.188-6.173 8.497-9l.002-.001c2.349-2.868 4.231-5.569 5.663-8.103 2.814-5.038 4.196-10.172 4.196-15.427 0-6.55-2.014-11.686-5.93-15.601l-.01-.01-.01-.01c-3.895-4.01-8.92-6.05-15.253-6.05-6.57 0-11.831 2.158-15.952 6.42-4.087 4.23-6.181 9.666-6.188 16.482l.023.66H20.5v-.672c0-3.05.394-5.646 1.406-7.549.522-.98 1.231-1.82 2.169-2.407.944-.592 2.006-.856 3.113-.856 2.06 0 3.78.898 4.964 2.584 1.126 1.602 1.582 3.614 1.582 5.837 0 3.92-.939 7.723-2.784 11.386",
    fill: "#D0DF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "2_svg__a",
    x: 0.094,
    y: 0.313,
    width: 64.766,
    height: 82.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "2_svg__b",
    x: 0.094,
    y: 0.313,
    width: 64.766,
    height: 82.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
};
export default Svg2;